var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"effect"},[(_vm.randVal === 0)?_c('cough'):_c('kidney')],1)}
var staticRenderFns = []

export { render, staticRenderFns }